export default __webpack_public_path__ + "static/media/help-dark.7572cbc5.svg";